// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./checkbox.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");

// accented characters to accept since javascript \w doesnt accept these by default
var accentedCharacters = "àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ";
var specialCharacters = "\.\!#\$\^%()+\;,\/\{\}\|\?";

function parse(text, next) {
    strip(require('raw!./checkbox.html'), function(theOutputHtml) {
        // since we need to do this as a "new RegExp" we need to use double \ everywhere
        var parseRe = new RegExp("\\[(\\w[\\w" + accentedCharacters + specialCharacters + "\\ \\t\\-]*)(?:\\:{1}([A-Za-z0-9]+)?)?(\\*?)\\s*=[ \\t]*(\\[x?\\][ \\t]*[\\w \\t\\-]+[\\[\\]\\w" + accentedCharacters + specialCharacters + " \\t\\-\\>&;]*)\\]", "g");

        var match = parseRe.exec(text);
        while (match != null) {
            var container = document.createElement("div");
            container.innerHTML = theOutputHtml;
            var domObj = container.firstChild;
            //console.log(match[3]);

            var keyExtra = (typeof match[2] != 'undefined') ? 'data-keyextra="' + match[2] + '"' : '';

            var cleanedName = match[1].trim().replace(/\t/g, ' ');
            var inputName = cleanedName.replace(/[ \t]/g, '_').toLowerCase();

            var cleanedOptions = match[4].trim().replace(/\t/g, ' ');
            var labelName = cleanedName;

            // We have a very specific case  for the checkbox that is used with consent post.
            // We dont want to print the label in that specific case. Ugly but the job needs to be done.
            var output = ['denypost', 'consentpost', 'consentemail', 'denyemail', 'consentphone', 'denyphone'].indexOf(labelName) === -1 ? '<label>' + labelName + '</label>' : '';

            output += '<div class="mbgf-alignleft">';

            var optRegex = new RegExp("\\[(x?)\\][ \\t]*([\\w" + accentedCharacters + specialCharacters + " \\t\\-\\>&;]+)", "g");
            var optMatch = optRegex.exec(cleanedOptions);

            while (optMatch) {
                var namedOptionRegex = /(.+)\-(?:>|&gt;)(.+)/g;
                var namedOptionMatch = namedOptionRegex.exec(optMatch[2]);

                var id, checkboxLabel;

                var idSuffix = (!this.test) ? "_" + uniqueId() : "";

                if (namedOptionMatch) {
                    id = namedOptionMatch[1].trim().replace(/\t/g, ' ').replace(/[ \t]/g, '_').toLowerCase();
                    checkboxLabel = namedOptionMatch[2].trim();
                } else {
                    id = optMatch[2].trim().replace(/\t/g, ' ').replace(/[ \t]/g, '_').toLowerCase();
                    checkboxLabel = optMatch[2].trim().replace(/\t/g, ' ');
                }


                var checked = optMatch[1] == 'x';
                //output += ;
                output += '<input type="checkbox" name="' + inputName + '" id="' + id + idSuffix +
    					  '" value="' + id + '" ' + (checked ? 'checked="checked"' : '') + '' + keyExtra + '/>';


                if (checkboxLabel !== 'dont-show') {
                    output += '<label class="checkbox--label" for="' + id + idSuffix + '">' + checkboxLabel + '</label>';
                }

                optMatch = optRegex.exec(cleanedOptions);
            }

            output += '</div>';

            domObj.innerHTML = output;
            outputHtml = container.innerHTML;

            if (match[3] == "*") {
                var container = document.createElement("div");
                container.innerHTML = outputHtml;
                var checkboxBox = container.firstChild;

                var inputs = checkboxBox.getElementsByTagName("input");

                for (var i = 0; i < inputs.length; i++)
                {
                    inputs[i].setAttribute("required", "true");
                }

                // add a "required" class to the parent node
                checkboxBox.setAttribute("class", checkboxBox.getAttribute("class") + " required");
                checkboxBox.setAttribute("data-required", "true");

                outputHtml = container.innerHTML;
            }

            text = text.replace(match[0], outputHtml);

            match = parseRe.exec(text);
        }

        next(text);
    });

};

function uniqueId() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 8; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

function validate(context) {
    var ok = true;

    var inputs = context.getElementsByTagName("input");

    var required = context.getAttribute("data-required") == "true";

    // is the value ok? (not empty)
    if (required) {
        // loop through the checkboxed until we find one that is checked
        for (var i = 0; i < inputs.length; i++) {
            var foundOne = false;
            var checkedAttr = inputs[i].getAttribute('checked');

            foundOne = inputs[i].checked || (checkedAttr != null && (checkedAttr == '' || checkedAttr.toLowerCase() == 'checked' || checkedAttr.toLowerCase() == 'true'));

            // found and has a value?
            if (foundOne && inputs[i].value) {
                break;
            }
        }

        ok = ok && foundOne;
    }

    // is the value ok? (valid)

    for (var i = 0; i < inputs.length; i++) {
        var checkedAttr = inputs[i].getAttribute('checked');

        // is this one checked?
        var checked = (checkedAttr != null && (checkedAttr == '' || checkedAttr.toLowerCase() == 'checked' || checkedAttr.toLowerCase() == 'true'));

        if (checked)
        {
            ok = ok && !!inputs[i].value;
        }
    }

    var currentClasses = context.getAttribute("class") || "";

    if (!ok) {
        if (currentClasses.indexOf("error") == -1) {
            context.setAttribute("class", currentClasses + " error");
        }
    }
    else {
        currentClasses = currentClasses.replace(/(|\s)error(|\s)/g, "");
        context.setAttribute("class", currentClasses);
    }

    return ok;
}

function getDataKey(context) {
    var domInput = context.getElementsByTagName("input")[0];
    var key = domInput.getAttribute("name");

    var keyExtra = domInput.getAttribute("data-keyextra");
    if (keyExtra && keyExtra.length) {
        key += "." + keyExtra;
    }
    return key;
}

function get(context) {
    var inputs = context.getElementsByTagName("input");
    var values = [];

    for (var i = 0; i < inputs.length; i++) {
        var checkedAttr = inputs[i].getAttribute('checked');

        // is this one checked?
        var checked = (checkedAttr != null && (checkedAttr == '' || checkedAttr.toLowerCase() == 'checked' || checkedAttr.toLowerCase() == 'true')) || inputs[i].checked;

        if (checked) {
            values.push(inputs[i].value);
        }
    }

    var value = values.join();
    return value !== '' ? value : null;
}

function reset(context) {
    var inputs = context.getElementsByTagName("input");
    var values = [];

    for (var i = 0; i < inputs.length; i++) {
        inputs[i].checked = false;
    }
}

module.exports = {
    parse: parse,
    validate: validate,
    getDataKey: getDataKey,
    get: get,
    test: false,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/checkbox/checkbox.js